import React, { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { SettingsProps } from './SettingsContainer';
import {
  LengthUnitsGroupStrings,
  OverviewViewModeStrings,
  RTRMetricUnitGroupStrings,
  UserSettings,
  UserSystemGroupStrings,
} from 'store/storeTypes';
import MobileSettings from './MobileSettings';
import DesktopSettings from './DesktopSettings';

const Settings = React.memo((props: SettingsProps) => {
  const {
    userSettings,
    pbiReportHeight,
    pbiReportWidth,
    screenHeight,
    screenWidth,
    setAppUserSettings,
  } = props;
  const [isMobile, setIsMobile] = React.useState(false);
  useEffect(() => {
    if (screenWidth < 1366 || screenHeight < 766) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [pbiReportHeight, pbiReportWidth, screenWidth, screenHeight]);

  const [debouncedSetAppUserSettings] = useDebouncedCallback(
    // function
    (args: UserSettings) => {
      return setAppUserSettings(args);
    },
    // delay in ms
    300
  );

  const [updatedSettings, setUpdatedSettings] = useState(null);

  useEffect(() => {
    if (updatedSettings !== null) {
      debouncedSetAppUserSettings({
        ...userSettings.data, // settings from server
        ...updatedSettings, // new settings patch from client
      });
    }
  }, [updatedSettings]);

  const handleChangeLang = (event: React.ChangeEvent<HTMLInputElement>) => {
    if ((event.target as HTMLInputElement).value) {
      setUpdatedSettings({
        ...updatedSettings,
        portalLanguage: (event.target as HTMLInputElement).value,
      });
    }
  };

  // Need check only if not NULL because we use enums and we enum have 0
  const handleChangeDefaultValue = (
    event: React.MouseEvent<HTMLElement>,
    newVal: UserSystemGroupStrings
  ) => {
    if (newVal !== null) {
      setUpdatedSettings({
        ...updatedSettings,
        defaultSystemGroup: newVal,
      });
    }
  };

  const handleChangeViewMode = (
    event: React.MouseEvent<HTMLElement>,
    newVal: OverviewViewModeStrings
  ) => {
    if (newVal !== null) {
      setUpdatedSettings({
        ...updatedSettings,
        defaultShiftMode: newVal,
      });
    }
  };

  const handleChangeLength = (
    event: React.MouseEvent<HTMLElement>,
    newVal: LengthUnitsGroupStrings
  ) => {
    if (newVal !== null) {
      setUpdatedSettings({
        ...updatedSettings,
        lengthUnits: newVal,
      });
    }
  };

  const handleChangeMetrics = (
    event: React.MouseEvent<HTMLElement>,
    newVal: RTRMetricUnitGroupStrings
  ) => {
    if (newVal !== null) {
      setUpdatedSettings({
        ...updatedSettings,
        rtrMetricUnit: newVal,
      });
    }
  };
  if (isMobile) {
    return (
      <MobileSettings
        {...props}
        updatedSettings={updatedSettings}
        handleChangeDefaultValue={handleChangeDefaultValue}
        handleChangeViewMode={handleChangeViewMode}
        handleChangeLength={handleChangeLength}
        handleChangeMetrics={handleChangeMetrics}
        handleChangeLang={handleChangeLang}
      />
    );
  } else {
    return (
      <DesktopSettings
        {...props}
        updatedSettings={updatedSettings}
        handleChangeDefaultValue={handleChangeDefaultValue}
        handleChangeViewMode={handleChangeViewMode}
        handleChangeLength={handleChangeLength}
        handleChangeMetrics={handleChangeMetrics}
        handleChangeLang={handleChangeLang}
      />
    );
  }
});

export default Settings;
